import { render, staticRenderFns } from "./PopupConfirmMenu.vue?vue&type=template&id=2f0124b8&"
import script from "./PopupConfirmMenu.vue?vue&type=script&lang=ts&"
export * from "./PopupConfirmMenu.vue?vue&type=script&lang=ts&"
import style0 from "./PopupConfirmMenu.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports